module.exports = __webpack_public_path__ + "static/media/C++.d852ca36.png";